import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { appConfig } from '../app.config';
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configUrl = 'assets/settings.json';  // Fallback to settings.json for deployed environments (generated by Docker)
  private localConfigUrl = 'assets/env.local.json';  // Local dev config
  private config: any;
  private ApiConfig: any;

  constructor(private http: HttpClient) { }

  loadConfig(): Observable<any> {
    console.info('ConfigService: Attempting to load config from:', this.localConfigUrl);
    return this.http.get<any>(this.localConfigUrl).pipe(
      tap(config => {
        console.info('ConfigService: Successfully loaded config from local file:', config);
        this.config = config;
      }),
      catchError((error) => {
        console.warn('ConfigService: Failed to load local config, falling back to:', this.configUrl, error);
        return this.http.get<any>(this.configUrl).pipe(
          tap(config => {
            console.info('ConfigService: Successfully loaded config from fallback file:', config);
            this.config = config;
          })
        );
      })
    );
  }

  getConfig(): any {
    return this.config;
  }
  setApiConfig(data) {
    this.ApiConfig = data;
    appConfig.apikey = this.ApiConfig.HAPPI_API_KEY;
  }
  getApiConfig(): any {
    return this.ApiConfig;
  }
  decrypt(encryptedData: { content: string, key: string }): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedData.content, encryptedData.key);
      const decryptedJson = decryptedBytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedJson) {
        throw new Error("Decryption failed or malformed UTF-8 data");
      }
      return JSON.parse(decryptedJson);
    } catch (error) {
      console.error('Decryption error:', error);
      throw new Error('Failed to decrypt data');
    }
  }
}
